export const getTecPastSessionsOnboardingDetailsUrl = (): string | undefined =>
  import.meta.env.VITE_CHS_2858_DETAILS_URL ?? import.meta.env.REACT_APP_CHS_2858_DETAILS_URL;
